import React from 'react'

import useCoverage from '~/hooks/use-coverage'

import ZonesContent from './component'

function Zones() {
  const { loading, coverageImage, coverageTree } = useCoverage()

  if (loading) {
    return null
  }

  return <ZonesContent coverageImage={coverageImage} coverageTree={coverageTree} />
}

export default Zones
